<div class="modal fade-modal in-modal">
  <div class="modal-dialog modal-sm max-w-360">
    <div class="modal-content p-16">
      <div class="modal-body text-center">
        <app-title-desc
          classDesc="f13 m-0"
          classTitle="f12 m-0 mb-8"
          [desc]="'alerts.credentialsDescription' | translate"
          [title]="'alerts.credentialsTitle' | translate">
        </app-title-desc>

        <app-title-desc
          classDesc="f13 m-0 text-ellipsis"
          classDiv="radius-4 bg-white pt-10 pb-8 px-16 mt-8 text-left"
          classTitle="f11 text-ellipsis fw-normal color-psr-radio-button-bg transform-none m-0 mb-2"
          [desc]="email"
          [title]="'labels.email' | translate">
        </app-title-desc>

        <ps-input
          height="tall"
          inputClass="mt-8"
          name="password"
          type="password"
          [fieldLanguage]="currentLanguage"
          [formDataControl]="passwordControl"
          [label]="'labels.pass' | translate">
        </ps-input>
      </div>

      <div class="btns-footer flex align-items-center justify-content-between mt-16">
        <ps-button
          color="secondary"
          height="tall"
          [text]="'actions.cancel' | translate"
          (onClick)="closeModal()">
        </ps-button>
        <ps-button
          height="tall"
          [text]="'actions.continue' | translate"
          (onClick)="closeModal(true)">
        </ps-button>
      </div>
    </div>
  </div>
</div>
